// extracted by mini-css-extract-plugin
export default {"content":"C8kRD4wveDG3HY6aS68+TQ==","option":"_4hr2nMjWfl-WXK+r--AcQw=="};